export default __webpack_public_path__ + "static/media/Step 2 Image.e5900b51.png";